<template>
  <MarshallHome/>
</template>

<script>
import MarshallHome from '../components/marshall';
import { useHead } from '@vueuse/head';
import sanity from "../../sanity.js";

export default {
  name:'MarshallIndex',
  components:{
    MarshallHome,
  },
  data() {
    return {
      seo: null,
      content: null
    }
  },
  methods: {
    async fetchData() {
      const query = `*[_type == "home"]{
        seo {
          title,
          description,
          keywords,
          ogImage {
            asset->{
              url
            }
          }
        }
      }[0]`;
      this.error = this.home = null;
      this.loading = true;
      try {
        const content = await sanity.fetch(query);
        this.loading = false;
        this.content = content;

        // Call useHead after data is loaded
        useHead({
          title: `${content?.seo?.title || content?.title || 'Marshall Print'}`,
          meta: [
            { name: 'description', content: content?.seo?.description },
            { name: 'keywords', content: content?.seo?.keywords },
            // { property: 'og:title', content: content?.seo?.title },
            // { property: 'og:description', content: content?.seo?.description },
            // { property: 'og:image', content: content?.seo?.ogImage?.asset?.url },
          ]
        });
      } catch (error) {
        this.error = error;
      }
    },
  },
  async created() {
    await this.fetchData();
  }
}
</script>
